import React from 'react';
import ModulePlaceholder from 'app/components/districtModulesCommon/ModulePlaceholder';
import LoadingSkeleton from 'app/components/mediaModule/content/LoadingSkeleton';
export default function MediaModulePlaceholder(_ref) {
  let {
    districtName,
    pathname
  } = _ref;
  const text = "Es liegen keine Fotos oder Video-Highlights in den letzten 30 Tagen vor. Hier geht es zu allen\n            Medien-Inhalten aus dem Kreis ".concat(districtName, ".");
  return /*#__PURE__*/React.createElement(ModulePlaceholder, {
    text: text,
    buttonText: "Alle Inhalte anzeigen",
    link: "".concat(pathname, "/media"),
    linkRel: "nofollow",
    "data-sentry-element": "ModulePlaceholder",
    "data-sentry-component": "MediaModulePlaceholder",
    "data-sentry-source-file": "MediaModulePlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(LoadingSkeleton, {
    "data-sentry-element": "LoadingSkeleton",
    "data-sentry-source-file": "MediaModulePlaceholder.tsx"
  }));
}